import { createAsyncThunk } from "@reduxjs/toolkit";

import CameraAPI from "~/apis/CameraAPI";

export const assignStreamDevice = createAsyncThunk(
  "cameras/assignStreamDevice",
  async ({ streamId, deviceId }, thunkAPI) => {
    try {
      const response = await CameraAPI.assignStreamDevice({
        streamId,
        deviceId
      });

      return { stream: response.data };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response);
      }
    }
  }
);
